// Mock data para WING ACADEMY BRASIL

export const heroData = {
  title: "Domine a Console WING",
  subtitle: "com quem é referência",
  description: "Mentoria híbrida com Adeilson Chagas – Técnico de áudio e endorsee Behringer Brasil. 4 aulas ao vivo + mais de 20 aulas gravadas para dominar a console mais avançada do mercado.",
  ctaText: "GARANTIR MINHA VAGA",
  features: [
    { text: "4 Aulas ao Vivo", icon: "video" },
    { text: "20+ Aulas Gravadas", icon: "clock" },
    { text: "Acesso por 1 Ano", icon: "monitor" },
    { text: "Suporte + Comunidade", icon: "calendar" },
    { text: "Certificado Oficial", icon: "target" }
  ],
  limitedSpots: "NOVA TURMA — EM BREVE"
};

export const aboutCourse = {
  title: "Mentoria Híbrida de Alto Impacto",
  description: "4 aulas ao vivo para tirar todas as suas dúvidas + mais de 20 aulas gravadas disponíveis na plataforma exclusiva para alunos durante 1 ano.",
  highlights: [
    "4 aulas ao vivo com Adeilson Chagas",
    "Mais de 20 aulas gravadas na plataforma",
    "Suporte e comunidade exclusiva de alunos",
    "Acesso por 1 ano completo + Certificado Oficial"
  ]
};

export const consoleFeatures = {
  title: "Tecnologia de ponta, recursos de gigantes. Agora, nas suas mãos com a WING.",
  subtitle: "Engineered na Alemanha - A revolução digital no áudio profissional",
  features: [
    {
      title: "48 Canais Stereo Completos",
      description: "Processamento stereo total em todos os canais com Flex-Channels (stereo, mono, M/S)",
      icon: "layers"
    },
    {
      title: "16 Engines de Efeitos Stereo",
      description: "+80 FX profissionais de classe mundial sem usar processamento de canal",
      icon: "sparkles"
    },
    {
      title: "Midas PRO Mic Preamps",
      description: "Transparência e clareza de áudio sem precedentes em cada entrada",
      icon: "mic"
    },
    {
      title: "Interface USB 48 Canais",
      description: "Gravação/reprodução profissional + 64 tracks em SD card simultâneos",
      icon: "usb"
    },
    {
      title: "Controle Total Remoto",
      description: "5 apps gratuitos para Mac, PC, Linux, iOS e Android",
      icon: "smartphone"
    },
    {
      title: "Processamento 40-bit",
      description: "Máxima resolução de som para clareza e range dinâmico incomparáveis",
      icon: "activity"
    }
  ]
};

export const modules = [
  {
    number: "01",
    title: "Fundamentos e Organização",
    topics: [
      "Introdução à Família WING",
      "Anatomia da Console",
      "Primeiros Passos",
      "Organização Input e Output List"
    ]
  },
  {
    number: "02",
    title: "Roteamento e Sources",
    topics: [
      "Conceito de Sources",
      "Roteamento Avançado",
      "Fader Banks e Layers",
      "Conectividade Digital",
      "AES50/Stage Connect",
      "Redes TCP/IP - Básico"
    ]
  },
  {
    number: "03",
    title: "Processamento de Áudio",
    topics: [
      "Processamento de Canal",
      "Efeitos e Emulações Premium",
      "Roteamento de Efeitos",
      "Processamento de Bus",
      "Main Master e Matrix"
    ]
  },
  {
    number: "04",
    title: "Mixagem Avançada",
    topics: [
      "Técnicas de Mixagem",
      "DCAs e Sub Grupos",
      "Compressão Paralela",
      "Plano X na Mix",
      "Mixando Live e PA",
      "Mixando Monitor"
    ]
  },
  {
    number: "05",
    title: "Workflow e Produtividade",
    topics: [
      "Otimização de Workflow",
      "Gravação SD Card/USB/DAW",
      "Networking e Controle Remoto",
      "Custom Controls"
    ]
  },
  {
    number: "06",
    title: "Wing EDIT",
    topics: [
      "Criando Cenas",
      "Mix de Live pelo Edit",
      "Personalizando Custom Controls",
      "Usando Pop Out"
    ]
  }
];

export const bonuses = [
  {
    title: "05 Multitracks Profissionais",
    description: "Para estudo de mix e prática",
    icon: "music"
  },
  {
    title: "01 Ebook Técnico",
    description: "Guia completo sobre Equalizador",
    icon: "book"
  },
  {
    title: "01 Cordão Personalizado",
    description: "Cordão oficial Behringer",
    icon: "award"
  },
  {
    title: "01 Camisa Oficial",
    description: "Camisa WING Academy exclusiva",
    icon: "shirt"
  }
];

export const instructor = {
  name: "Adeilson Chagas",
  title: "Técnico de Áudio e Endorsee Behringer Brasil",
  description: "Especialista oficial da Behringer no Brasil, Adeilson Chagas é referência nacional em áudio profissional. Responsável pelos treinamentos oficiais WING Summit que percorrem o Brasil, já capacitou diversos profissionais em workshops oficiais da Behringer.",
  achievements: [
    "Endorsee oficial Behringer Brasil",
    "Instrutor dos eventos WING Summit",
    "Especialista em Console WING"
  ]
};

export const testimonials = [
  {
    name: "Carlos Silva",
    role: "Técnico de Som - Igreja Batista Central",
    text: "O curso mudou completamente minha forma de trabalhar com a WING. O Adeilson tem uma didática incrível e as aulas gravadas me permitiram aprender no meu ritmo. Valeu cada centavo!",
    rating: 5
  },
  {
    name: "Mariana Santos",
    role: "Operadora de Áudio - Eventos Corporativos",
    text: "Finalmente consegui dominar os recursos avançados da console. Poder assistir as aulas quando quiser e participar das aulas ao vivo semanais fez toda a diferença no meu trabalho.",
    rating: 5
  },
  {
    name: "Rafael Oliveira",
    role: "Produtor Musical",
    text: "Conteúdo direto e objetivo. Mais de 20 aulas completas que me deram toda base necessária. Recomendo para todos que trabalham com WING!",
    rating: 5
  },
  {
    name: "Juliana Costa",
    role: "Técnica de Som - Shows e Eventos",
    text: "Os encontros ao vivo semanais são incríveis! Consigo tirar todas as minhas dúvidas e agora me sinto confiante para operar qualquer evento.",
    rating: 5
  }
];

export const pricing = {
  installments: "Valor em breve",
  installmentsNote: "",
  fullPrice: "",
  limitedOffer: "Turma com início em breve!",
  spots: "VAGAS LIMITADAS",
  groupType: "GRUPO FECHADO"
};

export const faqData = [
  {
    question: "Preciso ter uma console WING para fazer a mentoria?",
    answer: "Não é obrigatório, mas é altamente recomendado para praticar. Se você não tem acesso a uma WING, pode usar o software WING EDIT para acompanhar as aulas e praticar offline."
  },
  {
    question: "Por quanto tempo tenho acesso às aulas gravadas?",
    answer: "Você tem acesso às aulas gravadas na plataforma exclusiva por 1 ano completo a partir da data de inscrição. Tempo suficiente para revisar todo o conteúdo quantas vezes precisar."
  },
  {
    question: "Como funciona a mentoria?",
    answer: "A mentoria é híbrida e tem duração de 4 semanas: são 4 aulas ao vivo com o Adeilson — 1 encontro por semana, via Zoom — para tirar dúvidas em tempo real, além de mais de 20 aulas gravadas na plataforma exclusiva. As aulas ao vivo também ficam gravadas para você rever quando quiser."
  },
  {
    question: "Qual o nível de conhecimento necessário?",
    answer: "A mentoria é adequada tanto para iniciantes quanto para técnicos que já trabalham com a WING e querem aprofundar seus conhecimentos. Começamos do básico e evoluímos para recursos avançados."
  },
  {
    question: "Como funciona a garantia?",
    answer: "Você conta com duas camadas de segurança. Primeiro, ANTES de qualquer pagamento, fazemos uma entrevista individual com você para esclarecer todas as dúvidas e confirmar se a mentoria faz sentido para o seu momento. Depois, já matriculado, você ainda tem garantia de 100% de devolução em até 7 dias — contados a partir da primeira aula ao vivo. Se sentir que o conteúdo não é para você, devolvemos todo o valor, sem burocracia."
  },
  {
    question: "Recebo certificado?",
    answer: "Sim! Ao concluir a mentoria, você recebe um certificado oficial de conclusão da WING Academy Brasil."
  },
  {
    question: "Qual a forma de pagamento?",
    answer: "O valor da turma será divulgado em breve. O pagamento é feito via Mercado Pago (ambiente 100% seguro), com opção de parcelamento no cartão de crédito."
  },
  {
    question: "Quando começa a turma?",
    answer: "A nova turma começa em breve. As vagas são limitadas para garantir qualidade no atendimento e interação durante as aulas ao vivo — garanta a sua o quanto antes."
  }
];

export const guarantee = {
  title: "Garantia de Satisfação",
  description: "Antes do pagamento, você tem uma entrevista individual com a WING Academy para esclarecer todas as dúvidas — só avança quem tem certeza de que é o momento certo.",
  details: "E, após a matrícula, se nos primeiros 7 dias (contados a partir da primeira aula ao vivo) você não estiver satisfeito, devolvemos 100% do investimento. Sem perguntas, sem burocracia.",
  badge: "100% Garantido"
};
